

import { useSelector } from 'react-redux';
import { StepConnector, styled } from "@mui/material";
import styles from "./stepperStyle.module.css";
import { SvgIcon } from "@mui/material";


// [
//     {
//         "label": "Step 1",
//         "description": "Identity verification",
//         "substeps": [
//             {
//                 "name": "Pan Verify"
//             },
//             {
//                 "name": "Aadhaar Verify"
//             }
//         ],
//         "path": "/step-1"
//     },
//     {
//         "description": "Link Bank Account",
//         "name": "Link Bank Account",
//         "path": "/step-2"
//     },
//     {
//         "description": "KYC verification",
//         "name": "DigiLocker KYC verified Docs",
//         "path": "/step-3"
//     },
//     {
//         "description": "Activate F&O",
//         "name": "Activate F&O",
//         "path": "/step-4"
//     },
//     {
//         "description": "Personal Details",
//         "name": "Personal Details",
//         "substeps": [
//             {
//                 "name": "Personal Detail"
//             },
//             {
//                 "name": "Occupation"
//             },
//             {
//                 "name": "Qualification"
//             }
//         ],
//         "path": "/step-5"
//     },
//     {
//         "description": "Add Nominee",
//         "name": "Add Nominee",
//         "path": "/step-6"
//     },
//     {
//         "description": "Signature",
//         "name": "Signature",
//         "path": "/step-8"
//     }
// ]
// Define your steps configuration
const defaultSteps = [
  {
    label: "Step 1",
    description: "Pan verification",
     name: "Pan Verify",
    // substeps: [
    //   { name: 'Pan Verify' },
    //   { name: 'Aadhaar Verify' }
    // ],
    path: "/step-1"
  },

  {
    description: "KYC verification",
    name: "DigiLocker KYC verified Docs",
    path: "/step-2"
  },
    {
    description: "Link Bank Account",
    name: "Link Bank Account",
    path: "/step-3"
  },
  {
    description: 'Activate F&O',
    name: "Activate F&O",
    path: "/step-4"
  },
  {
    description: 'Personal Details',
    name: "Personal Details",
    substeps: [
      {name:"Personal Detail"},
      { name: 'Occupation' },
      { name: 'Qualification' }
    ],
    path: "/step-5"
  },
  {
    description: "Add Nominee",
    name: "Add Nominee",
    path: "/step-6"
  },
  {
    description: "Capture Selfie",
    name: "Capture Selfie",
    path: "/step-7"
  },
  {
    description: "Signature",
    name: "Signature",
    path: "/step-8"
  }
];

export const useSteps = () => {
  const { userData } = useSelector(state => state.user);
  const backendResponse = userData.steps;

  const filteredSteps = defaultSteps
    .map(step => {
      const substeps = step.substeps?.filter(sub => backendResponse[sub.name]) || null;

      if (substeps && substeps.length > 0) {
        return { ...step, substeps };
      }

      if (!substeps && backendResponse[step.name]) {
        return step;
      }

      return null;
    })
    .filter(Boolean);

  return filteredSteps;
};

// console.log('steps',steps);

// Custom step connector styling
export const CustomStepConnector = styled(StepConnector)(() => ({
  "& .MuiStepConnector-line": {
    borderColor: "#897EFF !important",
    borderWidth: "2.5px",
    minHeight: "36px",
    marginRight: "auto",
    marginLeft: "42px",
    "@media (max-height: 810px)": {
      minHeight: "30px",
      marginLeft: "40px",
    },
    "@media (max-height: 740px)": {
      minHeight: "30px",
      marginLeft: "36px",
    },
    "@media (max-height: 720px)": {
      minHeight: "30px",
      marginLeft: "33px",
    },
    "@media (max-height: 680px)": {
      minHeight: "30px",
      marginLeft: "31px",
    },
  },
}));


// Helper function to get step status from backend response
export const getStepStatus = (step, backendResponse) => {
  console.log("BRRR",backendResponse)
  if (step.substeps) {
    // For steps with substeps (like PAN Details)
    const allCompleted = step.substeps.every(sub => backendResponse[sub.name]?.status);
    const anyAttempted = step.substeps.some(sub => backendResponse[sub.name]?.timestamp);
    const anySkipped = step.substeps.some(sub => 
      backendResponse[sub.name]?.status === false && 
      backendResponse[sub.name]?.timestamp !== null 
    );

    const anySkipped1=step.substeps.some(sub => 
        backendResponse[sub.name]?.status === true
      );



    console.log(step.description,"SUB",{
        completed: allCompleted,
        notAttempted: !anyAttempted,
        skipped: allCompleted ? false : (anySkipped || anySkipped1)
      })
    
    return {
      completed: allCompleted,
      notAttempted: !anyAttempted,
      skipped: allCompleted ? false : (anySkipped || anySkipped1)
    };
  } else {
    // For regular steps
    const stepData = backendResponse[step.name] ;

    // console.log(stepData)

    console.log(step.description,"REGULAR",{
        completed: stepData?.status || false,
        notAttempted: !stepData?.status && !stepData?.timestamp,
        skipped: !stepData?.status && stepData?.timestamp !== null
      })
    return {
      completed: stepData?.status || false,
      notAttempted: !stepData?.status && !stepData?.timestamp,
      skipped: !stepData?.status && stepData?.timestamp !== null
    };
  }
};



// Step icon component with backend-aware status

export const StepIcon = ({
    active,
    isCompleted,
    isSkipped,
    icon,
    stepIndex
  }) => {
    if (active) {
      return (
        <SvgIcon className={styles.svgstyle}>
          {/* Active step SVG */}
          <svg
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="14.5" cy="14.5" r="14" stroke="#2C1848" />
                    <path
                        d="M14.5 5.57697C9.56998 5.57697 5.57692 9.57003 5.57692 14.5C5.57692 19.43 9.56998 23.4231 14.5 23.4231C19.43 23.4231 23.4231 19.43 23.4231 14.5C23.4231 9.57003 19.43 5.57697 14.5 5.57697ZM10.3173 14.6673C9.85441 14.6673 9.48077 14.2937 9.48077 13.8308C9.48077 13.3679 9.85441 12.9943 10.3173 12.9943C10.7802 12.9943 11.1538 13.3688 11.1538 13.8308C11.1538 14.2928 10.7802 14.6673 10.3173 14.6673Z"
                        fill="#897EFF"
                    />
                </svg>
        </SvgIcon>
      );
    }
  
    if (isSkipped) {
      return (
        <SvgIcon className={styles.svgstyle}>
          {/* Skipped step SVG */}
              <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <circle cx="14.5" cy="14.5" r="14" stroke="#FFBB33" />
                  <g clip-path="url(#clip0_1614_364)">
                      <path
                          d="M14.5 23C19.1944 23 23 19.1944 23 14.5C23 9.80558 19.1944 6 14.5 6C9.80558 6 6 9.80558 6 14.5C6 19.1944 9.80558 23 14.5 23Z"
                          fill="#FFBB33"
                      />
                      <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.65 16.5982L13.3669 9.85335C13.3103 8.50479 15.6885 8.46557 15.6331 9.79673L15.35 16.5982C15.3307 17.0627 14.9682 17.4481 14.5001 17.4481C14.032 17.4481 13.6696 17.0659 13.65 16.5982Z"
                          fill="#2A163E"
                      />
                      <path
                          d="M15.3509 19.3185C15.3509 18.8485 14.97 18.4675 14.5 18.4675C14.03 18.4675 13.649 18.8485 13.649 19.3185C13.649 19.7884 14.03 20.1694 14.5 20.1694C14.97 20.1694 15.3509 19.7884 15.3509 19.3185Z"
                          fill="#2A163E"
                      />
                  </g>
                  <defs>
                      <clipPath id="clip0_1614_364">
                          <rect
                              width="17"
                              height="17"
                              fill="white"
                              transform="translate(6 6)"
                          />
                      </clipPath>
                  </defs>
              </svg>
        </SvgIcon>
      );
    }
  
    if (isCompleted) {
      return (
        <SvgIcon className={styles.svgstyle}>
          {/* Completed step SVG */}
                          <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
             <circle cx="26" cy="26" r="24" stroke="#57AB3A" strokeWidth="4" />
             <path
                 d="M26 10C17.16 10 10 17.16 10 26C10 34.84 17.16 42 26 42C34.84 42 42 34.84 42 26C42 17.16 34.84 10 26 10ZM18.5 26.3C17.67 26.3 17 25.63 17 24.8C17 23.97 17.67 23.3 18.5 23.3C19.33 23.3 20 23.97 20 24.8C20 25.63 19.33 26.3 18.5 26.3ZM35.54 22.63L27.21 30.96C26.58 31.58 25.76 31.93 24.87 31.93C23.99 31.93 23.16 31.58 22.54 30.96L20.25 28.67C19.67 28.09 19.67 27.14 20.25 26.55C20.84 25.97 21.79 25.97 22.37 26.55L24.66 28.84C24.8 28.99 24.94 28.99 25.09 28.84L33.42 20.51C34 19.93 34.95 19.93 35.54 20.51C36.12 21.1 36.12 22.05 35.54 22.63Z"
                 fill="#57AB3A"
             />
         </svg>
        </SvgIcon>
      );
    }
  
    return (
      <SvgIcon className={styles.svgstyle}>
        {/* Default step SVG */}
                   <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="14.5" cy="14.5" r="14" stroke="#897EFF" />
            </svg>
      </SvgIcon>
    );
  };



// Helper functions to check step status
// export const isStepCompleted = (stepIndex, backendResponse) => {
  
//   const step = steps[stepIndex];
//   return getStepStatus(step, backendResponse).completed;
// };

// export const isStepSkipped = (stepIndex, backendResponse) => {
//   const step = steps[stepIndex];
//   return getStepStatus(step, backendResponse).skipped;
// };

// export const isStepNotAttempted = (stepIndex, backendResponse) => {
//   const step = steps[stepIndex];
//   return getStepStatus(step, backendResponse).notAttempted;
// };
